import Box from '@mui/material/Box';
import * as React from 'react';
import LeftSideBar from '../../LeftSideBar';
import ProtectedRoutes from '../../omegaRoutes/ProtectedRoutes';


function Layout() {
    const drawerWidth = 270;
    return (
        <Box sx={{ display: 'flex' }}>
            {/* ........Header......... */}

            {/* ........Left side bar......... */}
            <LeftSideBar />

            {/* ........body......... */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1, p: 3,
                    width: { xs: `calc(100% - ${drawerWidth}px)`, sm: `calc(100% - ${drawerWidth}px)`, md: `calc(100% - ${drawerWidth}px)` }
                }}>
                <div className='main-content'>
                    <ProtectedRoutes></ProtectedRoutes>
                </div>
            </Box>
        </Box>
    );
}

export default Layout;